import { Component, OnDestroy } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { IonicPage, NavParams, ViewController } from "ionic-angular";
import { Action } from "models/order-management/models";
import * as moment from "moment-timezone";
import { OrderManagementDataService } from "providers/order-management-data-service/order-management-data-service";
import { UtilityService } from "providers/utility-service/utility-service";
import { Observable } from "rxjs";
import { forkJoin } from "rxjs/observable/forkJoin";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import { BasePage } from "../../base-page";

@IonicPage()
@Component({
  selector: "add-notes-popover",
  templateUrl: "add-notes.html",
})
export class AddNotesPopup extends BasePage implements OnDestroy {
  selected = 0;
  addNoteForm: FormGroup;
  ordersId = [];
  userDisplayName: string;
  notes: string;
  enableSave: boolean = true;

  constructor(
    public stateDate: StateManagementService,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private orderManagementDataService: OrderManagementDataService,
    private utilService: UtilityService
  ) {
    super(stateDate);
    this.addNoteForm = new FormGroup({
      note: new FormControl(""),
    });
    this.selected = this.navParams.data.addNoteOrders.length;
    this.ordersId = this.navParams.data.addNoteOrders;
    this.userDisplayName = this.navParams.data.userDisplayName;
  }

  onDismiss() {
    this.viewCtrl.dismiss({ cancel: true, shouldReload: false });
  }

  addNote() {
    let errors$ = [];
    this.utilService.increaseSpinnerCount("Adding notes ...");
    forkJoin(
      this.ordersId.map((order) =>
        this.orderManagementDataService
          .updateOrder(order, {
            notes: this.notes,
            actionType: Action.ActionTypeEnum.NotesAdded,
            displayName: this.userDisplayName,
            timezone: moment.tz.guess(),
          })
          .catch(() => Observable.of(errors$.push(order)))
      )
    ).subscribe(
      () => {
        this.viewCtrl.dismiss({ errors$, shouldReload: true });
      },
      () => {},
      () => this.utilService.decreaseSpinnerCount()
    );
  }

  /**
   * CO-3361 r2. Gates the Save button. Two fixes here:
   *
   * 1. NULL-SAFETY. Ionic 3 fires (ionChange) on an untouched control, and an
   *    untouched <ion-textarea> reports its model as `undefined` rather than
   *    "". `this.notes.length` threw a TypeError before the user had typed
   *    anything, killing the very handler that gates Save.
   * 2. TRIM. An operational note is append-only — there is no delete for one
   *    anywhere in the app — so a note of pure whitespace was saved to an
   *    order's history permanently. Blank is blank.
   *
   * (`enableSave` reads as "disable Save": it is bound to `[disabled]`.)
   */
  enableSaveButton() {
    this.enableSave = !this.notes || this.notes.trim().length === 0;
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-managment/add-notes/add-notes.ts